<div class="history-table-wrapper">
  <div class="controls">
    <input type="text" placeholder="Filter" [(ngModel)]="filterText" />
    <button type="button" (click)="load()" [disabled]="loading">Reload</button>
  </div>
  <div *ngIf="loading" class="status loading">Loading...</div>
  <div *ngIf="error" class="status error">{{ error }}</div>
  <div *ngIf="!loading && !error && !filteredEntries.length" class="status empty">No history entries</div>
  <table *ngIf="!loading && !error && filteredEntries.length" class="history-table">
    <thead>
      <tr>
        <th>Date/Time (ET)</th>
        <th>User</th>
        <th>Field</th>
        <th>Old</th>
        <th>New</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let e of filteredEntries">
        <td>{{ e.timestamp | date:'yyyy-MM-dd HH:mm:ss' }} <span class="tz-inline">ET</span></td>
        <td>{{ e.user }}</td>
        <td>{{ e.fieldLabel }}</td>
        <td class="old">{{ e.oldValue === '' || e.oldValue == null ? '—' : e.oldValue }}</td>
        <td class="new">{{ e.newValue === '' || e.newValue == null ? '—' : e.newValue }}</td>
      </tr>
    </tbody>
  </table>
</div>